import * as Yup from 'yup';

const SelfDeliveryReportEmailChangeSchema = Yup.object().shape({
  newEmail: Yup.string()
    .trim('The field cannot contain only spaces.')
    .required('Please enter email')
    .email('Please enter a valid email')
});

export default SelfDeliveryReportEmailChangeSchema;
